import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { siteColumnData } from '../Data/ColumnData';
import SyncfusionDataTable from './syncfusionDataTable';
import useGetDocs from '../CustomHooks/useGetDocs';
import { useHistory } from 'react-router-dom';
import { Autocomplete, Chip, CircularProgress, Grid, Paper, TextField, Tooltip } from '@mui/material';
import { DropzoneUpload } from './InputRendered';
import { useSelector } from 'react-redux';
import SummaryCard from './SummaryCard';

const notesFields = [
  {
    key: 'siteNotesforOperatorsOnly',
    label: 'Site Notes for Operators',
    placeholder: 'Enter notes for operators...',
  },
  {
    key: 'siteNotesforHaulageOnly',
    label: 'Site Notes for Drivers',
    placeholder: 'Enter notes for drivers...',
  },
  {
    key: 'siteNotesforForestManagerOnly',
    label: 'Site Notes for Forest Manager',
    placeholder: 'Enter notes for forest manager...',
  },
  {
    key: 'additionalManagementNotes',
    label: 'Additional Management Notes',
    placeholder: 'Enter additional notes...',
  },
];

const SiteInfoDialog = ({
  open,
  setOpen,
  siteInfoData,
  siteMainData, //siteMainData.isContractCreated
  handelSiteInfoEdit,
  showSiteMap,
  deleteProductData,
  handleNewSectionAddClick,
  openRouteView,
  files,
  handleFileChange,
  handleDeleteFiles,
  viewFile,
  isLoading,
  samplesData,
  notes,
  handleSiteNotes,
  saveSiteNotes,
  customerLocations,
}) => {
  useGetDocs(siteMainData?.siteAssessmentID || '');

  const history = useHistory();

  const [siteRef, setSiteRef] = useState('');
  const [siteCRMId, setSiteCRMId] = useState();

  useEffect(() => {
    setSiteRef(siteMainData.siteDetailsRef);
    setSiteCRMId(siteMainData.crmID);
  }, []);

  const handleClose = () => {
    saveSiteNotes(siteMainData, siteRef, siteCRMId);
    setOpen(false);
  };
  console.log(siteMainData, 'dte');
  const isContractCreated = Boolean(siteMainData.isContractCreated);

  const headerUIArray = {
    // info: (
    //   <Button size="small" variant="contained" color="primary" onClick={showFiles}>
    //     View Images / Docs
    //   </Button>
    // ),
    geolocations: (
      <>
        <Button size="small" variant="contained" color="primary" onClick={showSiteMap}>
          Show Map
        </Button>
        <Button style={{ marginLeft: '1rem' }} size="small" variant="contained" color="primary" onClick={openRouteView}>
          Show Route Map
        </Button>
      </>
    ),
    products: (
      <Button
        size="small"
        variant="contained"
        color="primary"
        onClick={() => {
          handleNewSectionAddClick('products');
        }}>
        Add New Product
      </Button>
    ),
    // species: (
    //   <Button
    //     size="small"
    //     variant="contained"
    //     color="primary"
    //     onClick={() => {
    //       handleNewSectionAddClick('species');
    //     }}>
    //     Add New Species
    //   </Button>
    // ),
    // uploadedDocs: (
    //   <>
    //     <Grid container spacing={2}>
    //       <Grid item xs={12} md={6}>
    //         <Box
    //           sx={{
    //             display: 'flex',
    //             overflowX: 'auto',
    //             gap: 1,
    //             py: 1,
    //             px: 0.5,
    //           }}>
    //           {loadingDocs ? (
    //             <Typography variant="body2">Loading documents…</Typography>
    //           ) : !Array.isArray(uploadedDocs) || uploadedDocs.length === 0 ? (
    //             <Typography variant="body2">No documents uploaded.</Typography>
    //           ) : (
    //             uploadedDocs.map((file, index) => (
    //               <Tooltip title={file.documentName} key={index}>
    //                 <Chip
    //                   label={file.documentName?.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName}
    //                   color="success"
    //                   sx={{
    //                     fontSize: '0.7rem',
    //                     height: '24px',
    //                     px: 1,
    //                   }}
    //                   onClick={() => viewSiteDoc(file)}
    //                 />
    //               </Tooltip>
    //             ))
    //           )}
    //         </Box>
    //       </Grid>
    //     </Grid>
    //   </>
    // ),
  };
  const canDeleteRowSections = {
    products: true,
    // species: true,
    samples: true,
  };
  const deleteFnc = {
    products: (data, name) => {
      console.log(name);
      console.log(data);
      deleteProductData(data.id, data.siteAssessmentID, false);
    },
    // species: (data, name) => {
    //   console.log(name);
    //   console.log(data);
    //   deleteSpecies(data.id, data.siteAssessmentID, false);
    // },
  };
  const minWidth = {
    harvesting: '1900px',
  };

  return (
    <Dialog disablePortal disableAutoFocus maxWidth="xl" open={open} onClose={handleClose}>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography sx={{ fontSize: '2rem', fontWeight: 'bold' }} component="span">
            Site Assessment - ID : {siteMainData.siteAssessmentID || ''}
          </Typography>

          <Box sx={{ marginLeft: '30px', display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography component="span">Site Ref : </Typography>
            <TextField
              variant="outlined"
              size="small"
              sx={{ width: '250px' }}
              value={siteRef}
              onChange={e => setSiteRef(e.target.value)}
              // onBlur={e => saveSiteRef(siteMainData, e.target.value, siteCRMId)}
            />
          </Box>
          <Box sx={{ ml: '30px', display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography component="span">CRM Id :</Typography>

            <Autocomplete
              options={customerLocations}
              getOptionLabel={option => option.label + ' - ' + option.value}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              value={customerLocations.find(opt => opt.value === siteCRMId) || null}
              onChange={(event, newValue) => {
                setSiteCRMId(newValue ? newValue.value : '');
              }}
              sx={{ width: 350 }}
              renderInput={params => <TextField {...params} size="small" placeholder="Search customer" />}
            />
          </Box>

          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: 8 }}
            onClick={() => history.push('/crm/contactsOverview-page')}>
            Manage Contact
          </Button>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ maxHeight: '75vh', overflowY: 'auto' }}>
        <Box
          noValidate
          component="div"
          className="SiteInfoDialog"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            width: '100%',
          }}>
          <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
            <SummaryCard value={siteMainData.siteAssessmentType} label="Site Assessment Type" />

            <SummaryCard value={siteMainData.siteAssessmentCategory} label="Site Assessment Category" />
          </Box>

          {Object.keys(siteColumnData).map((section, index) => {
            return (
              <SyncfusionDataTable
                key={index}
                sectionName={section === 'siteVolume' ? 'Site Volume (Consolidated)' : section}
                columns={siteColumnData[section]}
                data={section === 'siteVolume' ? samplesData : siteInfoData[section]}
                handelSiteInfoEdit={handelSiteInfoEdit}
                headerUI={headerUIArray[section]}
                canDeleteRowSections={canDeleteRowSections[section] || false}
                deletefnc={deleteFnc[section] || null}
                minWidth={minWidth[section]}
                isContractCreated={isContractCreated}
              />
            );
          })}

          <Box sx={{ marginBottom: 4, flexShrink: 0 }}>
            <Typography variant="h3" fontWeight="bold" gutterBottom>
              Notes
            </Typography>

            {notesFields.map((field, index) => (
              <Box key={index} mt={4}>
                <Typography variant="h6" style={{ fontSize: '13px', fontWeight: 'normal' }}>
                  {field.label}
                </Typography>
                <TextField
                  fullWidth
                  multiline
                  minRows={2}
                  variant="outlined"
                  value={notes?.[field.key] || ''}
                  onChange={e => handleSiteNotes(field.key, e.target.value)}
                  placeholder={field.placeholder}
                />
              </Box>
            ))}
          </Box>

          <Box sx={{ marginBottom: 4, flexShrink: 0 }}>
            <Typography variant="h3" style={{ fontWeight: 'bold' }}>
              Documents
            </Typography>

            {/* Discontinued --- <ImageViewer docs={files} /> */}
            <Grid item xs={12} md={6}>
              {!isContractCreated && <DropzoneUpload label="" onFileSelect={handleFileChange('files')} multiple={true} />}{' '}
              <Box
                sx={{
                  display: 'flex',
                  overflowX: 'auto',
                  gap: 1,
                  py: 1,
                  px: 0.5,
                  alignItems: 'center',
                  minHeight: 60,
                }}>
                {isLoading ? (
                  <Box sx={{ display: 'flex' }}>
                    <CircularProgress size={22} />
                    <Typography style={{ marginLeft: 8 }}>Fetching Docs ...</Typography>
                  </Box>
                ) : files && files.length > 0 ? (
                  files.map((file, index) => (
                    <Tooltip title={file.documentName} key={index}>
                      <div>
                        <Chip
                          label={file.documentName.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName}
                          color="success"
                          sx={{
                            fontSize: '0.7rem',
                            height: '24px',
                            px: 1,
                          }}
                          onDelete={() => {
                            !isContractCreated && handleDeleteFiles(file);
                          }} //handleDeleteFiles(file)
                          onClick={() => viewFile(file)}
                        />
                      </div>
                    </Tooltip>
                  ))
                ) : (
                  <Typography>No files uploaded.</Typography>
                )}
              </Box>
            </Grid>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleClose}>
          Save and Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(SiteInfoDialog);
